<template>
  <div class="acomodar">
    <div class="mx-4 mt-4">
      <!-- Cabecera de la sección -->
      <div class="bg-white rounded-3 p-4 mb-4 border shadow-sm">
        <div class="d-flex align-items-center mb-2">
          <i class="bi bi-file-earmark-text text-primary me-3 fs-1"></i>
          <div>
            <h4 class="fw-bold text-primary mb-1">REPORTES DE CONTRATOS</h4>
            <p class="fw-semibold text-secondary mb-0">GESTIÓN Y RENOVACIONES DE PERSONAL</p>
          </div>
        </div>
      </div>

      <!-- Grid Dinámico de Reportes -->
      <div class="row g-3">
        <!-- Reporte Especial con Filtros -->
        <CardReporte 
          titulo="Reporte Renovación"
          descripcion="Selecciona un año y mes para descargar el reporte filtrado."
          endpoint="ReportesExcel/ReporteRenovacionModulo"
          :fileName="`Reporte_Renovaciones_${perAno}${perMes}.xlsx`"
          :requireParams="true"
          :extraParams="{ idTrabajador, perAno, perMes }"
        >
          <template #filters>
            <select class="form-select mb-2" v-model="perAno">
              <option value="0" disabled>-- AÑO --</option>
              <option v-for="a in años" :key="a" :value="a">{{ a }}</option>
            </select>
            <select class="form-select" v-model="perMes">
              <option value="0" disabled>-- MES --</option>
              <option v-for="m in meses" :key="m.value" :value="m.value">{{ m.label }}</option>
            </select>
          </template>
        </CardReporte>

     

      </div>
    </div>
  </div>
</template>

<script>
import CardReporte from "@/components/CardReporte.vue";

export default {
  name: 'CopiasReporteRenovacion',
  components: {
    CardReporte,
  },
  data() {
    return {
      idTrabajador: localStorage.getItem('idTrabajdor'),
      perAno: "0",
      perMes: "0",
      años: ["2022", "2023", "2024", "2025", "2026"],
      meses: [
        { value: "01", label: "Enero" }, { value: "02", label: "Febrero" },
        { value: "03", label: "Marzo" }, { value: "04", label: "Abril" },
        { value: "05", label: "Mayo" }, { value: "06", label: "Junio" },
        { value: "07", label: "Julio" }, { value: "08", label: "Agosto" },
        { value: "09", label: "Septiembre" }, { value: "10", label: "Octubre" },
        { value: "11", label: "Noviembre" }, { value: "12", label: "Diciembre" }
      ],
      otrosReportes: [
        {
          titulo: "Contratos por Vencer",
          descripcion: "Listado de personal con contrato próximo a terminar",
          endpoint: "ReportesExcel/ReporteRenovacionModulo",
          fileName: "Contratos_Por_Vencer.xlsx",
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("acciones/CambioNavbar", true);
  },
  methods: {
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  margin-top: 9px;
  margin-bottom: 9px;
  padding-bottom: 20px;
  margin-right: 0.5%;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}
</style>